import React from 'react';

export default function UnsupportedWidget({ widgetType }) {
  return (
    <div className="re-widget-empty">
      Unsupported widget type: {widgetType || 'unknown'}
    </div>
  );
}
